<div class="card" >
  <div class="card-body">
    <app-doc-fill-info-bci-hr *ngIf="isBCI" [onboardingDocUserId]="onboardingDocUserId" > </app-doc-fill-info-bci-hr>
    <app-doc-fill-info-i9form-hr *ngIf="isI9Form" [onboardingDocUserId]="onboardingDocUserId"  [doNotNavigate]="false"> </app-doc-fill-info-i9form-hr>
  </div>
</div>
